import { render, staticRenderFns } from "./HealthWork.vue?vue&type=template&id=312acc14&"
import script from "./HealthWork.vue?vue&type=script&lang=ts&"
export * from "./HealthWork.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports